import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _div, _DropdownCaret;

import React from 'react';
import styled from 'styled-components';
import chroma from 'chroma-js';
import { DownOutlined } from '@ant-design/icons';
import { Dropdown } from 'antd';
var ProfileButton = styled.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: 4px;\n  padding: 0.3rem 0.5rem;\n  cursor: pointer;\n  transition: all ease 0.2s;\n\n  &:hover {\n    background-color: ", ";\n    border-color: ", ";\n  }\n"])), function (props) {
  return props.theme.colors.light;
}, function (props) {
  return chroma(props.theme.colors.grey).darken(0.5).hex();
}, function (props) {
  return props.theme.colors.grey;
}, function (props) {
  return props.theme.colors.grey;
});
var PicturePlaceholder = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 2.25rem;\n  height: 2.25rem;\n  background-image: ", ";\n  background-size: cover;\n  background-position: center;\n  background-color: ", ";\n  color: ", ";\n  border-radius: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-evenly;\n  flex-shrink: 0;\n  margin-right: 0.5rem;\n\n  @media only screen and (max-width: ", ") {\n    display: none;\n  }\n"])), function (props) {
  return "url(".concat(props.picture, ")");
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.light;
}, function (props) {
  var _props$theme$breakpoi;

  return ((_props$theme$breakpoi = props.theme.breakpoints) === null || _props$theme$breakpoi === void 0 ? void 0 : _props$theme$breakpoi.sm) && '576px';
});
var ProfileContent = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  max-width: 10rem;\n  align-items: start;\n  margin-right: 0.5rem;\n"])));
var ContentTitle = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 0.85rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n"])), function (props) {
  return props.theme.colors.dark;
});
var ContentSubtitle = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 0.8rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n"])), function (props) {
  return props.theme.colors.darkGrey;
});
var DropdownCaret = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  align-self: baseline;\n  font-size: 0.6rem;\n  padding-top: 0.35rem;\n\n  & > span.anticon {\n    transition: all ease 0.2s;\n    transform: rotate(", ");\n  }\n"])), function (props) {
  return props.transformRotate ? '180deg' : '0deg';
});

var getInitial = function getInitial(fullName) {
  var chunkedName = fullName.split(' ');
  return "".concat(chunkedName[0].charAt(0)).concat(chunkedName[chunkedName.length - 1].charAt(0)).toUpperCase();
};

var ProfileCardDropdown = function ProfileCardDropdown(_ref) {
  var _ref$dataTestid = _ref['data-testid'],
      dataTestId = _ref$dataTestid === void 0 ? 'btnProfile' : _ref$dataTestid,
      overlay = _ref.overlay,
      _ref$picture = _ref.picture,
      picture = _ref$picture === void 0 ? '' : _ref$picture,
      _ref$subtitle = _ref.subtitle,
      subtitle = _ref$subtitle === void 0 ? '' : _ref$subtitle,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title;
  return (
    /*#__PURE__*/
    // @ts-ignore no children in dropdown type?
    React.createElement(Dropdown, {
      overlay: overlay || _div || (_div = /*#__PURE__*/React.createElement("div", null)),
      placement: "bottomRight",
      trigger: ['click']
    }, /*#__PURE__*/React.createElement(ProfileButton, {
      "data-testid": dataTestId
    }, /*#__PURE__*/React.createElement(PicturePlaceholder, {
      "data-testid": "".concat(dataTestId, "Picture"),
      picture: picture
    }, !picture && getInitial(title)), /*#__PURE__*/React.createElement(ProfileContent, null, /*#__PURE__*/React.createElement(ContentTitle, {
      "data-testid": "".concat(dataTestId, "Title")
    }, title), /*#__PURE__*/React.createElement(ContentSubtitle, {
      "data-testid": "".concat(dataTestId, "SubTitle")
    }, subtitle)), _DropdownCaret || (_DropdownCaret = /*#__PURE__*/React.createElement(DropdownCaret, {
      transformRotate: false
    }, /*#__PURE__*/React.createElement(DownOutlined // @ts-ignore
    , {
      size: "sm"
    })))))
  );
};

export default ProfileCardDropdown;